import React from 'react';
import Navbar from "../../components/base/Navbar";
import Footer from "../../components/base/Footer";
import BlogList from "../components/BlogList";

const BlogPanel = () => {

    return (
        <div className="bg-gray-200 pt-24 bg-center">

            <Navbar/>

            <div className="mb-48">
                <div className="w-full "></div>

                <h1 className="text-3xl">Admin Panel - Blog Posts</h1>

                <a className="absolute cursor-pointer right-32 top-28 bg-blue-500 rounded-lg py-2 px-5 text-white hover:ring-2"
                   href="/admin">Zurück</a>

                <div className="w-full m-12"></div>

                <a className="cursor-pointer ml-12 bg-blue-500 rounded-lg py-2 px-5 text-white hover:ring-2"
                   href="/admin/blogs/new">Neuer Blog</a>

                <div className="w-full m-12"></div>

                <div className="m-auto">
                    <BlogList/>
                </div>

                <div className="w-full m-12"></div>
            </div>

            <Footer/>
        </div>
    );
}

export default BlogPanel;